<template>
  <div>
    <b-tabs v-model="tabIndex" lazy fill Justified>
      <b-tab title="Theo dõi thiết bị thuê và đổi trả">
        <Rent ref="rentRef" />
      </b-tab>
      <b-tab title="Theo dõi phụ lục thuê">
        <Returns @selectCode="onSelectCode" />
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
  import Rent from './rent.vue'
  import Returns from './return.vue'
  import { mapGetters } from 'vuex'
  export default {
    name: 'RENT_DEVICE',
    data() {
      return {
        tabIndex: 0,
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      onSelectCode(code) {
        this.tabIndex = 0
        this.$nextTick(() => {
          this.$refs.rentRef.setSearch(code)
        })
      },
    },
    components: { Rent, Returns },
  }
</script>
